module.exports = __webpack_public_path__ + "static/media/contact-header.a584c65d.jpg";